import CouponsIcon from '@material-ui/icons/ArrowRightOutlined';
import { APP_TYPES, roles } from '../../../config/constants';
import ScheduleList from '../ScheduleList';

const options = {
  appTypes: [APP_TYPES.ALL],
  allowedRoles: [roles.ADMIN, roles.BA, roles.JTI_TEAM, roles.RSM, roles.USER],
  label: 'Coupons',
  subMenuName: 'scheduleList',
};

export default {
  list: ScheduleList,
  icon: CouponsIcon,
  name: 'admin/schedule/type/coupon',
  options,
};
